import ZZLogisticsService from '../../services/ZZLogisticsService';
import zzLogisticsUseCase from './zzLogisticsUseCase';

const zzLogisticsFactory = zzLogisticsUseCase({
  ZZLogisticsService: ZZLogisticsService(),
});

export default zzLogisticsFactory;
